import { memoizeFunction } from '@fluentui/react';

import { SetTooltipProps } from '@1js/acui-common';

import { AppContextType } from './AppContext';

/**
 * React context uses shallow props comparison to determine when to re-render children. If the value of the
 * context provider is not the same reference as the last reference value, there will always be a re-render.
 */
export const makeAppContextValue = memoizeFunction(
  (
    isExperimentalFeatureEnabled: ((feature: string, defaultValue?: boolean) => boolean) | undefined,
    setTooltipElement?: (tooltipProps: SetTooltipProps) => void,
    updateTooltipsHidden?: (hideAllTooltips: boolean) => void
  ): AppContextType => ({
    isExperimentalFeatureEnabled,
    setTooltipElement,
    updateTooltipsHidden,
  })
);
